<template>
  <a-layout-footer class="pr-layout-footer">
    <a-button type="link" @click="privacyNotice">
      {{ $t('user.Privacy Notice') }}
    </a-button>
    |
    <a-button type="link" @click="logout">{{ $t('user.Log out') }}</a-button>
  </a-layout-footer>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'PrLayoutFooter',
    props: {
      mode: {
        type: String,
        default: 'base', //admin
      },
    },
    data() {
      return {}
    },

    methods: {
      async logout() {
        this.$store.dispatch('user/logout')
        return this.$router.push(`/login`)
      },
      async privacyNotice() {
        if (this.mode === 'admin') {
          return this.$router.push(`/master/privacy`)
        }
        return this.$router.push(`/privacy`)
      },
    },
  }
</script>

<style lang="less">
  @import url('@/styles/params.less');
  .ant-layout-footer {
    height: @app-footer-height;
    color: @primary-color;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
